<template>
    <div class="formContainer">
        <div class="iframeHider"></div>
        <iframe class="iframeContainer" :src="getLink()" scrolling="no" @load="pageLoad()"></iframe>
    </div>
</template>
<script>
export default {
    created() {
        if(this.$root.$data.transaction.page == 'lazada') {
            this.transType = 'WT';
            this.referenceNumber = '';
        } else {
            this.transType = this.$root.$data.transaction.referenceNumber.substring(0, 2);
            this.referenceNumber = this.$root.$data.transaction.referenceNumber;
        }
        let g4params = {
            'userId': this.$root.$data.account.userId,
            'cuid': this.$root.$data.account.cuid,
            'ip': this.$root.transaction.ipAddress,
            'user_agent': this.$root.$data.analyticsData.userAgent,
            'phone': this.$root.$data.analyticsData.phone,
            'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
            'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
            'transaction_type': this.transType,
            'transaction_reference': this.referenceNumber,
        }       
        this.$root.triggerG4Event('feedback_page',g4params);
        this.$dialog.alert('', {
            view: 'loader',
            html: true,
            customClass: 'dialog-sm',
        });
        this.$root.$data.previousView = 'feedback';
    },
    data() {
        return {
            comments:null,
            suggestions:null,
            error:{
                submit: false
            }
        }
    },
    methods: {
        submit() {
            this.$root.showLoader();
            axios.post("feedback?tid=" + this.$root.tid, {
                comments: this.comments,
                suggestions: this.suggestions
            }).then(response => {
                this.$dialog.$root.forceCloseAll();
                if(response.data.valid) {
                    this.$dialog.alert('Request completed!', {
                        view: 'feedback-complete',
                        html: true
                    })
                }else {
                    this.error.submit = true;
                }
            })
        },
        getLink() {
            return this.$root.$data.complete ? 'https://bit.ly/2SrVqME' : 'https://bit.ly/34rzCq1'
        },
        pageLoad() {
            window.dispatchEvent(new CustomEvent("loading", {
                detail: false
            }));
        }
    }
}
</script>
<style scoped>
    .headerDivider {
        border-top: 3px solid #FAFAFA;
    }
    .errorIcon {
        height: auto;
        width: 1rem;
    }

    .formContainer {
        display:block;
        width: 30rem;
        height: 65rem;
        overflow-y: hidden;
    }

    .iframeContainer {
        border-style: none;
        display: block;
        width: 30rem;
        height: 80rem;
        overflow:hidden;
    }
</style>